export default "__VITE_ASSET__DXaFFCTL__"